import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { enterFirstName, enterLastName } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import FormDoubleInput from "./form/formDoubleInput.component";

const Name: React.FC = () => {
  const dispatch = useDispatch();

  const firstName = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.firstName
  );

  const lastName = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.lastName
  );

  const onInputChange1 = (event: any) => {
    const { value } = event.target;
    dispatch(enterFirstName(value));
  };

  const onInputChange2 = (event: any) => {
    const { value } = event.target;
    dispatch(enterLastName(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"02"} title={"What is your name?"} />
        <FormDoubleInput
          onInputChangeOne={onInputChange1}
          onInputChangeTwo={onInputChange2}
          valueOne={firstName}
          placeholderOne={"Your first name"}
          valueTwo={lastName}
          placeholderTwo={"Your last name"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Name;
